import { connect } from 'react-redux'

import { fetchLogIn } from '../../authorized-controls/authorizationActions'
import Login from './Login'

const mapStateToProps = (state) => ({
  isLogInPending: state.authorization.isLogInPending,
  loginError: state.authorization.loginError
})

const mapDispatchToProps = (dispatch) => ({
  onLogInClick: (email, password, keepLoggedIn) => dispatch(fetchLogIn(email, password, keepLoggedIn))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)
